export default "__VITE_PUBLIC_ASSET__c083ac20__"